import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    gap: 24px;
  `};
`;

export const Container = styled.div`
  ${({ theme, $error, $widthFull }) => css`
    align-items: flex-start;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    padding: 24px;

    ${$widthFull && css`
      width: 100%;
    `}

    ${$error && css`
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: 16px;
      justify-content: center;
      padding: 58px;

      > * {
        align-items: center;
        display: flex;
        justify-content: center;
        margin: 0px;
        max-width: 640px;
        text-align: center;
        width: 100%;
      }
    `}
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SelectFieldContainer = styled.div`
  width: 60px;
`;

export const HistoryWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 0;
    }
  `};
`;

export const CircleProgressBarWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 30px;
    justify-content: space-around;

    @media screen (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const CircleProgressBarContent = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: flex-start;

    @media screen (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const CircleProgressBarVideoWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 10px;

    @media(max-width: ${theme.v2.breakpoints.lg}) {
      margin-bottom: 20px;
      align-items: center;
      justify-content: center;
    }
  `}
`;

export const CircleProgressBarVideoTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    gap: 8px;
    margin: 0px;

    @media(max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const CircleProgressBarDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const DesktopIconWrapper = styled.span`
  ${({ theme }) => css`
    @media(max-width: ${theme.v2.breakpoints.lg}) {
      display: none;
    }

    @media(min-width: ${theme.v2.breakpoints.lg}) {
      display: block;
    }

    svg {
      flex: 0 0 24px
    }
  `}
`;

export const MobileIconWrapper = styled.span`
  ${({ theme }) => css`
    @media(max-width: ${theme.v2.breakpoints.lg}) {
      display: block;
    }

    @media(min-width: ${theme.v2.breakpoints.lg}) {
      display: none;
    }

    svg {
      flex: 0 0 24px
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    flex-direction: row;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;

    @media(max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const CircleProgressBarDescriptionTitle = styled(Title)`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
  `}
`;

export const CircleProgressBarColorsList = styled.ul`
  align-items: center;
  display: inline-flex;
  flex-direction: row;
  gap: 40px;
  justify-content: center;
  margin: 0px;
  padding: 0px;
`;

export const CircleProgressBarColorsListItem = styled.li`
  ${({ theme, $variant }) => {
    const variants = {
      good: theme.v2.colors.feedback.activePure,
      neutral: theme.v2.colors.feedback.attentionPure,
      bad: theme.v2.colors.feedback.problemPure,
    };


    return css`
      color: ${theme.v2.colors.neutral.lowPure};
      display: flex;
      flex-direction: row;
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xxs};
      font-weight: ${theme.v2.font.weights.medium};
      gap: 8px;
      line-height: ${theme.v2.font.lineHeight.text};
      list-style-type: none;
      margin: 0px;

      &:before {
        background-color: ${variants[$variant]};
        border-radius: 100%;
        content: ' ';
        display: inline-block;
        height: 12px;
        margin: 0px  9px 0px 0px;
        width: 12px;
      }
  `;
  }}
`;

export const AnalysisItemsContainer = styled.div`
  ${({ $listExpanded, $padding }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-height: ${$listExpanded ? '1000px' : '0px'};
    padding: ${$listExpanded && $padding ? '2px 2px 24px' : '0'};
    transition: 250ms ease-in-out;
    overflow: hidden;
  `};
`;

export const AnalysisItemsWrapper = styled.div`
  ${({ theme }) => css`
    gap: 16px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      grid-template-columns: repeat(4, 1fr);
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: repeat(3, 1fr);
      margin-bottom: 0;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      display: flex;
      flex-direction: column;
    }
  `}
`;

export const AnalysisMobileToggle = styled.div`
  ${({ theme, $listExpanded }) => css`
    align-items: center;
    display: flex;
    justify-content: center;
    margin: ${$listExpanded ? '24px 0px 0px 0px' : '0px'};
    transition: 250ms ease-in-out;

    @media(min-width: ${theme.v2.breakpoints.lg}) {
      display: none;
    }`
}
`;

export const AnalysisItemsCard = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    border-radius: 8px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 253px;
    padding: 16px;

    @media(max-width: ${theme.v2.breakpoints.lg}) {
      max-width: 100%;
      width: 100%;
    }
  `}
`;

export const AnalysisItemsCardTitle = styled(Title)`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    display: inline-block;
    font-size: ${theme.v2.font.sizes.xxs};
    gap: 8px;
    text-align: left;

    span{
      display: inline-block;
      svg {
        flex: 0 0 24px;
        margin-left: 4px;
        position: relative;
        top: 3px;
      }
    }
  `}
`;

export const AnalysisItemsCardValue = styled.p`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    flex-direction: row;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px;
    justify-content: center;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 16px 0px 0px 0px;
    width: 100%;

    @media(max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const DotColor = styled.span`
  ${({ theme, $variant }) => {
    const variants = {
      good: theme.v2.colors.feedback.activePure,
      neutral: theme.v2.colors.feedback.attentionPure,
      bad: theme.v2.colors.feedback.problemPure,
    };

    return css`
      background-color: ${variants[$variant]};
      border-radius: 100%;
      content: ' ';
      display: inline-block;
      height: 12px;
      margin: 0px  9px 0px 0p;
      width: 12px;
  `;
  }}
`;

export const FirstRow = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 16px 0px 0px 0px;

    @media(max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const SecondRow = styled(FirstRow)`
  margin: 16px 0px 0px 0px;
`;

export const AlertWrapper = styled.div`
  ${({ padding }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: space-between;
    margin-top: 16px;
    padding-bottom: ${padding ? '24px' : '0'};

    > button {
      max-width: fit-content;
    }

    div {
      padding: 0px;
      align-items: center;
    }
  `};
`;

export const ActionWrapper = styled.div`
  ${({ theme }) => css`
    margin: 24px 0px 0px 0px;

    @media(min-width: ${theme.v2.breakpoints.lg}) {
      max-width: 148px;
    }
  `}
`;

export const ViewRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ListTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 24px 0px 40px;
`;

export const TestDate = styled.span`
  ${({ theme, $hideOnDesktop, $hideOnMobile }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    display: block;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;

    ${$hideOnDesktop && css`
      @media(min-width: ${theme.v2.breakpoints.lg}) {
        display: none;
        hidden: true;
      }
    `}

    ${$hideOnMobile && css`
      @media(max-width: ${theme.v2.breakpoints.lg}) {
        display: none;
        hidden: true;
      }
    `}
  `}
`;

export const PaginationWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    justify-content: space-between;
    position: relative;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 20px;
    };
  `};
`;

export const PaginationEmptyItem = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `};
`;

export const PagesAmount = styled.div`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowMedium};
    display: flex;
    font-size: ${theme.v2.font.sizes.xxs};
    gap: 8px;
    right: 0;
  `};
`;

export const SkeletonList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Table = styled.table`
  border-spacing: 16px;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead``;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  ${({ theme, $head }) => css`
    td:last-child {
      text-align: right;
    }

    ${$head && css`
      border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    `};
  `};
`;

export const TableHead = styled.th`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-weight: ${theme.v2.font.weights.medium};
    padding: 16px 0;
    text-align: left;
  `};
`;

export const TableCell = styled.td`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    padding: 28px 0;
  `};
`;

export const PerformanceCell = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const HistoryItemDetails = styled.td.attrs({ colSpan: 4 })`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    padding: 0;
    text-align: left;
  `};
`;

export const MobileHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 0;
`;

export const MobileHistoryItem = styled.div`
  ${({ theme, $firstItem }) => css`
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-top: ${$firstItem && `1px solid ${theme.v2.colors.neutral.highMedium}`};
    display: flex;
    flex-direction: column;
    font-size: ${theme.v2.font.sizes.xxs};
    gap: 8px;
    padding: 16px 0;
  `};
`;

export const MobileItemText = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    gap: 8px;

    strong {
      font-weight: ${theme.v2.font.weights.medium};
      color: ${theme.v2.colors.neutral.lowPure};
    }
  `};
`;

export const MobileHistoryItemDetails = styled.div`
  padding: 0;
`;

export const DetailsButtonContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  button {
    display: flex;
    justify-content: flex-start;
    max-width: 180px;
    width: 100%;
  }
`;
